export const STEPS = {
    initial: '',
    syncSchema: 'sync',
    reviewSync: 'reviewSync',
}

export const Placeholders = {
    PORT: 5432,
}
